module.exports = __webpack_public_path__ + "static/img/2.1fea36b3.jpg";